/**
 * DriveDesk AI — small formatting helpers shared by the v1.3 Wave 2
 * Action Plan components. Kept dependency-free (no date library) since
 * the app already relies on native Intl formatting elsewhere.
 */

export function formatDateTime(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString(undefined, {
      weekday: "short",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export function formatTime(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
  } catch {
    return iso;
  }
}

// Turns a snake_case metric/changes_preview key (e.g. "lessons_to_reassign")
// into a readable label ("Lessons To Reassign") without needing per-plan-kind
// mapping tables — this is what lets one summary component work for every
// Action Plan kind (sick_day, weather_cancellation, draft_communication,
// reschedule_single) without special-casing each shape.
export function titleCaseKey(key) {
  return String(key)
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export const RESOLUTION_LABELS = {
  reassign_instructor: "Reassign instructor",
  reschedule_time: "Reschedule time",
  unresolved: "Needs manual attention",
};
